import { mediaUrl } from "./media";

/**
 * Optimize an image URL for the display size needed.
 *  - Unsplash: appends ?w=&q=&auto=format&fit=crop to serve properly-sized AVIF/WebP.
 *  - Backend uploads: resolve via mediaUrl.
 *  - Other URLs: returned as-is.
 */
export function optimizeImg(url, w = 800, q = 72) {
  if (!url) return "";
  if (url.startsWith("/api/")) return mediaUrl(url);
  try {
    const u = new URL(url);
    if (u.hostname.includes("unsplash.com") || u.hostname.includes("images.unsplash.com")) {
      u.searchParams.set("w", String(w));
      u.searchParams.set("q", String(q));
      u.searchParams.set("auto", "format");
      u.searchParams.set("fit", "crop");
      return u.toString();
    }
  } catch (e) {
    /* ignore */
  }
  return url;
}
